<ng-container [ngSwitch]="type">
    <ng-template ngSwitchCase="info">
        <i class="material-icons icon">info</i>
        <div class="text">{{ message }}</div>
        <button *ngIf="dismissible" type="button" class="dismiss-button" (click)="onDismiss($event)">
            <i class="material-icons">close</i>
        </button>
    </ng-template>
    <ng-template ngSwitchCase="warning">
        <i class="material-icons icon">warning</i>
        <div class="text">{{ message }}</div>
        <button *ngIf="dismissible" type="button" class="dismiss-button" (click)="onDismiss($event)">
            <i class="material-icons">close</i>
        </button>
    </ng-template>
    <ng-template ngSwitchCase="error">
        <i class="material-icons icon">error</i>
        <div class="text">{{ message }}</div>
        <button *ngIf="dismissible" type="button" class="dismiss-button" (click)="onDismiss($event)">
            <i class="material-icons">close</i>
        </button>
    </ng-template>
    <ng-template ngSwitchCase="custom">
        <i class="material-icons icon">{{ icon }}</i>
        <div class="text">
            <ng-container [ngTemplateOutlet]="errorTmpl"></ng-container>
        </div>
        <button *ngIf="dismissible" type="button" class="dismiss-button" (click)="onDismiss($event)">
            <i class="material-icons">close</i>
        </button>
    </ng-template>
</ng-container>
